import type { SpectralLineData } from "../types";
import { normalize } from "./normalize";
import { bunch } from "./bunch";
import { proximityThresholdNm } from "./settings";

const MIN_VISIBLE_NM = 380;
const MAX_VISIBLE_NM = 700;

export async function loadElement(
  symbol: string,
  thresholdOverride?: number,
): Promise<SpectralLineData[]> {
  const res = await fetch(`assets/elements/${symbol}.csv`);
  if (!res.ok) throw new Error(`Failed to load element ${symbol}: ${res.status}`);
  const text = await res.text();

  const raw: SpectralLineData[] = [];
  for (const line of text.split(/\r?\n/)) {
    if (!line) continue;
    const [wlStr, intStr] = line.split(",");
    const wlAngstrom = parseFloat(wlStr);
    const intensity = parseFloat(intStr);
    if (!Number.isFinite(wlAngstrom) || !Number.isFinite(intensity)) continue;
    const wlNm = wlAngstrom / 10;
    if (wlNm < MIN_VISIBLE_NM || wlNm > MAX_VISIBLE_NM) continue;
    raw.push({ wavelengthNm: wlNm, intensity, thicknessMultiplier: 1 });
  }

  const normalized = normalize(raw);
  const threshold = thresholdOverride ?? proximityThresholdNm(symbol);
  return bunch(normalized, threshold);
}
